import Alpine from 'alpinejs';

export type SexualOrientation = 'gay' | 'straight' | 'transexual';

export enum ABTestVariation {
    NON_PARTICIPANT = -1,
    CONTROL = 0,
    TREATMENT = 1,
}

export type GlobalAppData = {
    isMobile: boolean;
    hideExplicitContent?: boolean;
    ads: {
        liveCamAdZoneConfig: Record<string, { provider: string }>;
    };
    CDNROOT: string;
    user: {
        isLoggedIn: boolean;
        trId?: string;
    };
    // TODO: Remove after releasing Gravity Search project (ENABLE_GRAVITY_SEARCH)
    isGravitySearchEnabled: boolean;
    sexualOrientation: SexualOrientation;
    searchKeyword?: string;
};

export type SiteData = {
    global: GlobalAppData;
    page: Record<string, unknown>;
};

export type MagicVariables<T = any> = Partial<Alpine.Magics<T>>;
